<template>
  <img class="element-image" ref="imageRef" :src="element.image.data" :id="element.id" :style="imageStyle" />
</template>


<script>
import { gsap } from "gsap"
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js"
import getEnv from '@/utils/env'

gsap.registerPlugin(MotionPathPlugin)

export default {
  props: {
    element: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      required: true
    },
    layerWidthOriginal: {
      type: Number,
      required: true
    },
    layerHeightOriginal: {
      type: Number,
      required: true
    },
    layerSize: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      required: false
    },
    isMobileDevice: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      imageRef: null,
      browswerWindowWidth: this.isPreview ? this.layerSize.width : window.innerWidth,
      browserWindowHeight: this.isPreview ? this.layerSize.height : window.innerHeight,
      levelofDepth: this.level,
      originalWidthImg: 0,
      originalHeightImg: 0,
      offsetLeftMobile: parseFloat(getEnv('VUE_APP_OFFSET_LEFT_MOBILE')) || 0,
    }
  },
  computed: {
    imageStyle() {
      let newWidth = undefined
      let newHeight = undefined
      let newX = undefined
      let newY = undefined

      // if (this.isMobileDevice && window.screen.orientation.type.includes('landscape')) {
      //   const dmScaleWidth = window.innerWidth / 1920- (this.element.width * 2)
      //   const dmScaleHeigth = window.innerHeight / 1080
      //   newX = this.element.xPosition * dmScaleWidth
      //   newY = this.element.yPosition * dmScaleHeigth

      //   newWidth = this.originalWidthImg * dmScaleWidth * this.element.size / 100
      //   newHeight = this.originalHeightImg * dmScaleHeigth * this.element.size / 100
      // } else 
      if (this.isMobileDevice && window.screen.orientation.type.includes('portrait')) {

        //const leftOffsetScale = this.element.xPosition / this.layerWidthOriginal

        const dmScaleWidth = 0.5//innerWidth / this.layerWidthOriginal
        const dmScaleHeight = innerHeight / this.layerHeightOriginal
  

        newWidth = this.originalWidthImg  * (this.element.size / 100) * dmScaleWidth  
        newHeight = this.originalHeightImg * (this.element.size / 100)  * dmScaleHeight 

        newX = this.element.xPosition * dmScaleWidth
        newY = this.element.yPosition * dmScaleHeight

        if (this.element.speed == 0) {
        //  console.log("layerWidthOriginal: " + this.layerWidthOriginal)
        //  console.log("xPosition: " + this.xPosition)
          //newX = this.element.xPosition 
          newX = (this.element.xPosition / this.layerWidthOriginal) * ( innerWidth - newWidth)
        }
       // console.log("newX: " + newX)

      } else {
        var scaleWidth = 0
        var scaleHeight = 0
        if (this.element.speed > 0) {
          scaleWidth = this.layerSize.width / 1920 // scale widht = 1??
          scaleHeight = this.layerSize.height / 1080
        } else {
          scaleWidth = this.layerSize.width / 1920
          scaleHeight = this.layerSize.height / 1080

        }

        newWidth = this.originalWidthImg * scaleWidth * this.element.size / 100
        newHeight = this.originalHeightImg * scaleHeight * this.element.size / 100
        newX = this.element.xPosition * scaleWidth 
        newY = this.element.yPosition * scaleHeight
      }

      return {
        width: newWidth + 'px',
        height: newHeight + 'px',
        left: newX + 'px',
        top: newY + 'px',
        position: 'absolute',
        transform: this.element.speed < 0 ? 'scaleX(-1)' : 'scaleX(1)',
        'z-index': this.levelofDepth,
      }
    }
  },
  watch: {
    'element.speed': function (newSpeed) {
      if (newSpeed == 0) {
        // If new speed is 0, stop current animation and make the element stationary
        gsap.killTweensOf(this.imageRef) // Stop current animation
        gsap.set(this.imageRef, { autoAlpha: 1 }) // Optionally ensure the element is fully visible
      } else {
        // If there's a new speed, recalculate and apply new animation
        this.animateImage()
      }
    },
    element: {
      handler() {
        this.animateImage()
      },
      deep: true
    },
    originalWidthImg() {
      this.animateImage()
    },
  },
  methods: {
    handleResize() {
      this.browswerWindowWidth = window.innerWidth
      this.browserWindowHeight = window.innerHeight
      this.animateImage()
    },
    calculatedSpeed(maxX, imageWidth) {
      const speed = Math.abs(this.element.speed)
      const totalDistance = this.element.speed < 0 ? maxX + this.element.xPosition : maxX + this.element.xPosition + imageWidth
      const speedFactor = totalDistance / maxX
      if (speed == 0) {
        return Infinity
      } else {
        return 1 / (speed / 100 || 1) * 4 * speedFactor
      }
    },
    loadImageSize() {
      const img = new Image()
      img.src = this.element.image.data
      img.onload = () => {
        this.originalWidthImg = img.width 
        this.originalHeightImg = img.height
        //console.log("Element size: " + img.width + ", " + img.height)
        this.$forceUpdate() // Force update to recalculate computed properties
      }
    },
    movingElementAnimation(timeline, imageWidth, trajectory) {
      const maxX = this.isPreview ? this.layerSize.width : window.innerWidth
      let motionPathPoints;

      // Convert trajectory to array if it's not already
      if (!Array.isArray(trajectory)) {
        trajectory = trajectory.split(",").map(Number)
      }

      // Calculate motion path points based on the trajectory array
      if (trajectory && trajectory.length > 1) {
        const numPoints = trajectory.length
        const incrementX = maxX / (numPoints - 1)

        motionPathPoints = trajectory.map((point, index) => {
          const scaleX = incrementX * index
          const scaleY = point * this.browserWindowHeight / 1080 //recalculate y points
          return { x: scaleX, y: scaleY }
        })
      } else if (trajectory && trajectory.length === 1) {
        const fixedX = maxX / 2
        const scaleY = trajectory[0]
        motionPathPoints = [{ x: 0, y: 0 }, { x: fixedX, y: scaleY }, { x: maxX, y: scaleY }]
      } else {
        motionPathPoints = [{ x: 0, y: 0 }, { x: maxX, y: 0 }]
      }

      // Adjust start and end points based on the sign of speed
      if (this.element.speed < 0) {
        motionPathPoints.reverse()
        motionPathPoints[motionPathPoints.length - 1].x = -  imageWidth
        timeline.set(this.imageRef, {
          x: maxX + this.element.xPosition, // Start from the right side of the screen
          y: 0,
          transform: 'scaleX(-1)', // Flip horizontally
          left: 0
        })
      } else {
        timeline.set(this.imageRef, {
          x: -imageWidth - this.element.xPosition, // Start from the left side of the screen
          y: 0,
          transform: 'scaleX(1)',
          left: 0
        })
      }

      // Apply the animation
      return timeline.to(this.imageRef, {
        duration: this.calculatedSpeed(maxX, imageWidth),
        ease: "linear",
        motionPath: {
          path: motionPathPoints,
          autoRotate: false // Set to true for the element to rotate along the path aka uphill/ downhill
        }
      })
    },
    animateImage() {
      if (this.element.speed == 0) {
        // If speed is 0, ensure the element is stationary without initiating new animations
        gsap.killTweensOf(this.imageRef)// Ensures any ongoing animation is stopped
        return
      }

      gsap.killTweensOf(this.imageRef)
      const imageWidth = parseFloat(this.imageStyle.width)
      const mainTimeline = gsap.timeline({ repeat: -1, repeatDelay: 2 })
      this.movingElementAnimation(mainTimeline, imageWidth, this.element.path)
    },

  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.loadImageSize()
    this.imageRef = this.$refs.imageRef
   // console.log("xPosition: " + this.element.xPosition)
    this.animateImage()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    gsap.killTweensOf(this.imageRef)
  }
}
</script>

<style lang="scss" scoped>
.element-image {
  position: absolute;
  z-index: var(--levelofDepth);
  object-fit: fill;
}
</style>
